<div class="isg-click-filter-container" [ngStyle]="{'width': getWidth()}">

  <label class="isg-click-filter-label">

    <button type="button"
            class="isg-click-filter-pill"
            [disabled]="isDisabled()"
            (click)="onModelChange()">
      <i class="fa-light fa-filter"></i>
    </button>

    <span class="isg-click-filter-text">
      <span *ngIf="checked == true">{{textTrue()}}</span>
      <span *ngIf="checked == false">{{textFalse()}}</span>
      <span *ngIf="checked == null || checked == undefined">{{textNotSpecified()}}</span>
      <ng-content></ng-content>
    </span>

  </label>

</div>
